import React, { FC } from 'react';

type NoComponentType = { content: string | undefined; index: number };

const NoComponent: FC<any> = ({ content, index }: NoComponentType) => {
  return <div>{content ? content : `Tab No: ${index}`}</div>;
};

export default NoComponent;
